/* DSA productpagina: bundels, sticky balk, reviewslider, scroll naar reviews. */

(function () {
  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const hasPubSub = () =>
    typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined';

  /* ---------- Hoeveelheidskortingen ---------- */
  if (!customElements.get('dsa-quantity-breaks')) {
    customElements.define(
      'dsa-quantity-breaks',
      class DsaQuantityBreaks extends HTMLElement {
        connectedCallback() {
          this.sectionId = this.dataset.sectionId;
          this.optionsId = this.dataset.qbId;
          this.addEventListener('change', (event) => {
            if (event.target.matches('.dsa-qb__radio')) this.apply();
          });

          if (!this.querySelector('.dsa-qb__radio:checked')) {
            const first = this.querySelector('.dsa-qb__radio');
            if (first) first.checked = true;
          }
          this.apply();

          if (hasPubSub()) {
            // Dawn zet de hoeveelheid terug naar het minimum na een variantwissel of toevoeging; zet de keuze terug.
            this.unsubQuantity = subscribe(PUB_SUB_EVENTS.quantityUpdate, () => this.apply());
            this.unsubVariant = subscribe(PUB_SUB_EVENTS.variantChange, (event) => this.onVariantChange(event));
          }
        }

        disconnectedCallback() {
          if (this.unsubQuantity) this.unsubQuantity();
          if (this.unsubVariant) this.unsubVariant();
        }

        get input() {
          return this.querySelector('.quantity__input');
        }

        apply() {
          const checked = this.querySelector('.dsa-qb__radio:checked');
          const input = this.input;
          if (!checked || !input) return;
          const quantity = parseInt(checked.value, 10) || 1;
          if (String(input.value) !== String(quantity)) input.value = quantity;
          document.dispatchEvent(
            new CustomEvent('dsa:quantity-change', { detail: { sectionId: this.sectionId, quantity } })
          );
        }

        onVariantChange(event) {
          const data = event && event.data;
          if (!data || data.sectionId !== this.sectionId || !data.html) return;
          const fresh = data.html.getElementById(this.optionsId);
          const current = this.querySelector('#' + CSS.escape(this.optionsId));
          if (!fresh || !current) return;
          const keep = this.querySelector('.dsa-qb__radio:checked');
          const keepOption = keep ? keep.dataset.option : null;
          current.innerHTML = fresh.innerHTML;
          if (keepOption) {
            const same = current.querySelector(`.dsa-qb__radio[data-option="${keepOption}"]`);
            if (same) same.checked = true;
          }
          this.apply();
        }
      }
    );
  }

  /* ---------- Sticky winkelwagenbalk ---------- */
  if (!customElements.get('dsa-sticky-atc')) {
    customElements.define(
      'dsa-sticky-atc',
      class DsaStickyAtc extends HTMLElement {
        connectedCallback() {
          this.sectionId = this.dataset.sectionId;

          // Een vaste balk binnen een element met transform (scroll-animatie) breekt; verplaats naar body.
          document.querySelectorAll(`dsa-sticky-atc[data-section-id="${this.sectionId}"]`).forEach((other) => {
            if (other !== this) other.remove();
          });
          if (this.parentElement !== document.body) {
            document.body.appendChild(this);
            return; // connectedCallback draait opnieuw na verplaatsen
          }
          if (this.dataset.ready) return;
          this.dataset.ready = 'true';

          this.addEventListener('click', (event) => {
            if (event.target.closest('[data-dsa-sticky-button]')) this.onButton();
          });
          this.addEventListener('change', (event) => {
            if (event.target.matches('[data-dsa-sticky-select]')) this.selectVariant(event.target);
          });

          this.observe();
          if (hasPubSub()) {
            this.unsubVariant = subscribe(PUB_SUB_EVENTS.variantChange, (event) => this.onVariantChange(event));
          }
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
          if (this.unsubVariant) this.unsubVariant();
        }

        get target() {
          return document.getElementById('ProductSubmitButton-' + this.sectionId);
        }

        get form() {
          return document.getElementById(this.dataset.formId);
        }

        observe() {
          const target = this.target;
          const mode = this.dataset.displayWhen;
          if (!target || mode === 'always') {
            this.show(true);
            return;
          }
          this.observer = new IntersectionObserver(
            ([entry]) => {
              if (entry.isIntersecting) return this.show(false);
              const scrolledPast = entry.boundingClientRect.top < 0;
              this.show(mode === 'button_hidden' ? true : scrolledPast);
            },
            { threshold: 0 }
          );
          this.observer.observe(target);
        }

        show(visible) {
          this.classList.toggle('is-visible', visible);
        }

        onButton() {
          const button = this.querySelector('[data-dsa-sticky-button]');
          if (!button || button.disabled) return;
          const target = this.target;
          if (this.dataset.function === 'buy_now') return this.buyNow(button);
          if (target) target.click();
        }

        async buyNow(button) {
          const form = this.form;
          if (!form) return;
          button.classList.add('is-loading');
          try {
            const response = await fetch(`${root()}cart/add.js`, {
              method: 'POST',
              body: new FormData(form),
              headers: { Accept: 'application/json' },
            });
            if (!response.ok) throw new Error('add failed');
            window.location.href = `${root()}checkout`;
          } catch (error) {
            console.error(error);
            button.classList.remove('is-loading');
            if (this.target) this.target.click();
          }
        }

        selectVariant(select) {
          const optionsList = this.variantOptions;
          const index = select.selectedOptions[0] ? parseInt(select.selectedOptions[0].dataset.index, 10) : -1;
          const wanted = optionsList && optionsList[index];
          const info = document.getElementById('MainProduct-' + this.sectionId) || document.querySelector(`product-info[data-section="${this.sectionId}"]`);
          const selects = info && info.querySelector('variant-selects');
          if (!wanted || !selects) return;

          const groups = selects.querySelectorAll('fieldset, .product-form__input--dropdown');
          const changed = [];
          groups.forEach((group, i) => {
            const value = wanted[i];
            const dropdown = group.querySelector('select');
            if (dropdown) {
              if (dropdown.value !== value) {
                Array.from(dropdown.options).forEach((option) => {
                  const match = option.value === value;
                  option.selected = match;
                  if (match) option.setAttribute('selected', 'selected');
                  else option.removeAttribute('selected');
                });
                changed.push(dropdown);
              }
              return;
            }
            const radio = Array.from(group.querySelectorAll('input[type="radio"]')).find((r) => r.value === value);
            if (radio && !radio.checked) {
              radio.checked = true;
              changed.push(radio);
            }
          });
          // Alle waarden staan al goed; één change is genoeg, maar stuur ze na elkaar voor de zekerheid.
          changed.forEach((element) => element.dispatchEvent(new Event('change', { bubbles: true })));
        }

        get variantOptions() {
          try {
            return JSON.parse(this.querySelector('[data-dsa-variants]').textContent);
          } catch (error) {
            return null;
          }
        }

        onVariantChange(event) {
          const data = event && event.data;
          if (!data || data.sectionId !== this.sectionId || !data.html) return;
          const fresh = data.html.getElementById('dsa-sticky-inner-' + this.sectionId);
          const current = this.querySelector('#dsa-sticky-inner-' + this.sectionId);
          if (fresh && current) current.innerHTML = fresh.innerHTML;
        }
      }
    );
  }

  /* Ruim de naar body verplaatste balk op als de sectie in de editor verdwijnt. */
  document.addEventListener('shopify:section:unload', (event) => {
    const id = event.detail && event.detail.sectionId;
    if (!id) return;
    document.querySelectorAll(`dsa-sticky-atc[data-section-id="${id}"]`).forEach((el) => el.remove());
  });

  /* ---------- Reviewslider ---------- */
  if (!customElements.get('dsa-review-slider')) {
    customElements.define(
      'dsa-review-slider',
      class DsaReviewSlider extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.dsa-rv__track');
          if (!this.track || !this.classList.contains('dsa-rv--slider')) return;
          this.dots = Array.from(this.querySelectorAll('.dsa-rv__dot'));
          this.track.addEventListener('scroll', () => this.sync(), { passive: true });
          this.addEventListener('click', (event) => {
            const arrow = event.target.closest('.dsa-rv__arrow');
            if (arrow) return this.go(this.current + parseInt(arrow.dataset.dir, 10));
            const dot = event.target.closest('.dsa-rv__dot');
            if (dot) this.go(parseInt(dot.dataset.index, 10));
          });
          this.sync();

          const seconds = parseFloat(this.dataset.autoplay);
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (seconds > 0 && !reduce) {
            this.timer = setInterval(() => {
              if (this.matches(':hover') || this.contains(document.activeElement)) return;
              this.go(this.current + 1 >= this.slides.length ? 0 : this.current + 1);
            }, seconds * 1000);
          }
        }

        disconnectedCallback() {
          if (this.timer) clearInterval(this.timer);
        }

        get slides() {
          return Array.from(this.track.children);
        }

        get current() {
          const width = this.track.clientWidth || 1;
          return Math.round(this.track.scrollLeft / width);
        }

        go(index) {
          const slides = this.slides;
          const clamped = Math.max(0, Math.min(slides.length - 1, index));
          this.track.scrollTo({ left: slides[clamped].offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
        }

        sync() {
          const index = this.current;
          this.dots.forEach((dot, i) => dot.setAttribute('aria-current', i === index ? 'true' : 'false'));
        }
      }
    );
  }

  /* ---------- Sterren: scroll naar reviews ---------- */
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-dsa-scroll-to]');
    if (!link) return;
    const id = link.dataset.dsaScrollTo;
    const target = document.getElementById(id) || document.getElementById('shopify-section-' + id);
    if (!target) return;
    event.preventDefault();
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });
})();
